import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { AppBar, Toolbar, IconButton, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  onClose: () => void;
}

const useStyles = makeStyles(theme => ({
  title: {
    position: 'relative',
    justifyContent: 'center',
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    left: theme.spacing(2),
  },
}));

const Header: FC<Props> = ({ onClose }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <AppBar>
      <Toolbar className={classes.title}>
        <IconButton className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
        <Typography align="center" variant="h4">
          {t('sharing:shareToYourNetworks')}
        </Typography>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
